export interface LeaveGuardDeps {
  isDirty: () => boolean
  ask: () => Promise<boolean>
}

export function createLeaveGuard(deps: LeaveGuardDeps) {
  let approved = false

  return {
    async allowLeave() {
      if (!deps.isDirty() || approved) {
        return true
      }

      approved = await deps.ask()

      return approved
    },

    settle() {
      approved = false
    },
  }
}
